module.exports = __webpack_public_path__ + "static/media/logo.5159711b.svg";